import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import axios from 'axios';
import { Statistic } from '@b3w/react-statistic';
import api, { BASE_PATH, SERVICE_ALIAS } from 'constants/api';
import Loader from 'components/Loader/Loader';
import Footer from 'components/Footer/Footer';
import Header from 'components/Header/Header';
import AddToHomeScreen from 'components/AddToHomeScreen/AddToHomeScreen';
import MainPage from 'components/pages/MainPage/MainPage';
import InnerPage from 'components/pages/InnerPage/InnerPage';
import Page404 from 'components/pages/Page404/Page404';
import ErrorPage from 'components/pages/ErrorPage/ErrorPage';
import CardPage from 'components/pages/CardPage/CardPage';
import PPPortal from 'components/PPPortal/PPPortal';
import { useVerifyQuery } from 'generated/graphql';
import useFirebase from 'hooks/useFirebase';

import s from './App.module.scss';

function App() {
  const [ppText, setPpText] = useState('');
  const { data, loading, error } = useVerifyQuery();

  useFirebase();

  useEffect(() => {
    axios.get(`${BASE_PATH}/text/${SERVICE_ALIAS}/privacyfooter/1`)
      .then((res) => {
        if (res.data) setPpText(res.data);
      })
      .catch(() => {});
  }, []);

  const [supportText, setSupportText] = useState('');

  useEffect(() => {
    axios.get(api.headerSupport).then((response) => {
      setSupportText(response.data);
    });
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <ErrorPage />;
  }

  const verify = !!data?.point?.verify;
  const flowURL: string = data?.point?.flowURL ? data?.point?.flowURL : 'https://www.google.com/';

  return (
    <>
      <PPPortal text={ppText} />
      <div className={s.wrapper}>
        <Statistic
          path={`${BASE_PATH}/referer/statistic`}
          timeoutMinutes={1}
          from
        />
        <div
          className={s.headerSupport}
          dangerouslySetInnerHTML={{ __html: supportText }}
        />
        <Header />
        <Switch>
          <Route path="/user/conditions">
            <InnerPage url={api.offer} />
          </Route>
          <Route path="/privacypolicy">
            <InnerPage url={api.privacypolicy} />
          </Route>
          <Route
            path="/card_id/:id"
            render={() => (
              <CardPage
                verify={verify}
                flowURL={flowURL}
              />
            )}
          />
          <Route exact path="/error">
            <ErrorPage />
          </Route>
          <Route exact path="/">
            <MainPage />
          </Route>
          <Route>
            <Page404 />
          </Route>
          <Loader />
        </Switch>
        <Footer verify={verify} />
        <AddToHomeScreen />
      </div>
    </>
  );
}

export default App;
